module.exports = __webpack_public_path__ + "static/media/zola-theme-icons.40bf2db3.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./public/fonts/zola-theme-icons.ttf?24613844
 ** module id = 480
 ** module chunks = 44
 **/